import Vue from 'vue';

// When the request succeeds
const success = (data, resolve) => {
  resolve(data);
};

// When the request fails
const failed = (error, reject) => {
  reject(error);
};

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/wizard')
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/account/wizard.js